/**
 * Encounter lifecycle status — single source of truth for the chart Notes tab.
 *
 * Values are verbatim Flutter `app_constants.dart`
 * (`encounterStatusCompleted = "Completed"`, `encounterStatusDraft = "Draft"`);
 * the wire ships these exact strings on `EncounterModel.status`. Centralised so
 * a new/renamed status doesn't silently fall through the card render logic
 * (PR #445 review).
 */

export const ENCOUNTER_STATUS = {
  Completed: 'Completed',
  Draft: 'Draft',
} as const;

export type EncounterStatusPillLabel = 'Locked' | 'Draft' | 'Ongoing';

/**
 * Maps the raw encounter status to the Notes-card pill label, mirroring
 * Flutter `notes_tab.dart:141-152`:
 *   Completed → "Locked", Draft → "Draft", anything else → "Ongoing".
 */
export function encounterStatusLabel(
  status: string | null | undefined,
): EncounterStatusPillLabel {
  if (status === ENCOUNTER_STATUS.Completed) return 'Locked';
  if (status === ENCOUNTER_STATUS.Draft) return 'Draft';
  return 'Ongoing';
}

/**
 * Only Completed (Locked) encounters expose the read-only "View" action
 * (Flutter `notes_tab.dart`: View on Completed, Edit on Draft, nothing on
 * Ongoing). Drafts open via Edit in the Practitioner workspace — a separate
 * surface — so the chart Notes card shows no button for them.
 */
export function isLockedEncounter(status: string | null | undefined): boolean {
  return status === ENCOUNTER_STATUS.Completed;
}
